import adamPic from "@/public/images/artists/adam.jpg";
import { Artist } from "@/types/types";

export const adam = {
  id: "262",
  name: "Adam",
  image: adamPic,
  description: `Adam's voice sits in a mid, easygoing range, carrying a soft, controlled tone that glides over the melody without ever pushing or straining.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fadam-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Pop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 69,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
